import { render, staticRenderFns } from "./Client_obj_edit.vue?vue&type=template&id=7ac380cc"
import script from "./Client_obj_edit.vue?vue&type=script&lang=js"
export * from "./Client_obj_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports